
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

interface BrowseTabsProps {
  currentTab: string;
}

const BrowseTabs: React.FC<BrowseTabsProps> = ({ currentTab }) => {
  const location = useLocation();
  
  const tabs = [
    { id: "all", label: "All Agents", path: "/browse" },
    { id: "featured", label: "Featured", path: "/browse?tab=featured" },
    { id: "new", label: "New Releases", path: "/browse?tab=new" },
    { id: "popular", label: "Popular", path: "/browse?tab=popular" }
  ];

  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8">
        {tabs.map((tab) => (
          <Link
            key={tab.id}
            to={tab.path}
            className={cn(
              "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm",
              currentTab === tab.id
                ? "border-purple-600 text-purple-600"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            )}
            aria-current={currentTab === tab.id ? "page" : undefined}
          >
            {tab.label}
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default BrowseTabs;
